<template>
  <div>
      <v-row v-if="chave !== null && chave !== 1">
        <v-col cols="12" class="pl-0">
          <span class="text-subtitle-2">Informações Bens</span>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="4" class="pt-4 pl-0" v-if="chave === 18 || chave === 19|| chave === 99">
          <input-text label="Localização (País)" v-model="model.LocalizacaoPais" required />
        </v-col>
      </v-row>

      <v-col cols="4" class="pt-4 pl-0" v-if="chave === 16 && chave !== null">
        <input-text label="Registro de Embarcação" v-model="model.NroRegistro" required />
      </v-col>

      <v-col cols="4" class="pt-4 pl-0" v-if="chave === 17">
        <input-text label="Registro de Aeronave" v-model="model.NroRegistro" required />
      </v-col>

      <v-row  v-if="chave === 2" class="pt-2 pl-0">
        <v-col cols="3" class="pl-0">
          <input-text label="Marca / Fabricante" v-model="model.Marca" />
        </v-col>
        <v-col cols="3">
          <input-text label="Modelo" v-model="model.Modelo" />
        </v-col>
        <v-col cols="3">
          <input-text label="Número de Série" v-model="model.NroSerie" />
        </v-col>
        <v-col cols="3" class="pr-0">
          <input-number label="Número nota fiscal" v-model="model.NroNotaFiscal" />
        </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
  props: {
    chave: null,
    value: null,
  },
  data () {
    return {
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
